import { render, staticRenderFns } from "./DocsColorBlock.vue?vue&type=template&id=a6d73a02&scoped=true"
import script from "./DocsColorBlock.vue?vue&type=script&lang=js"
export * from "./DocsColorBlock.vue?vue&type=script&lang=js"
import style0 from "./DocsColorBlock.vue?vue&type=style&index=0&id=a6d73a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d73a02",
  null
  
)

export default component.exports